import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./Pages/Privacy";
import Welcome from "./Pages/Welcome";
import Home from "./Pages/Home";
import Layout from "./Component/Layout";
import LayoutDup from "./Component/Layout-dup";
import NewLayout from "./Component/NewLayout";
import MiaLayout from "./Component/MiaLayout";
import { useLocation } from 'react-router-dom';
import "./App.css";

import mockData from "./mock";

function App() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const mode = searchParams.get('mode');
  const selectedLayout = mode === 'old' ? <NewLayout /> : <MiaLayout/>;

  return (
    <div className="App">
      <Routes>
        {/* <Route path="/" element={<Welcome />}></Route> */}
        <Route path="/" element={selectedLayout}></Route>
        <Route path="/privacy" element={<PrivacyPolicy />}></Route>
      </Routes>
    </div>
  );
}

export default App;
